var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    width: 210.035,
    height: 38.423,
    viewBox: "0 0 210.035 38.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M214.251,48h3.619L209.615,27.34h-3.622L197.76,48h3.622l1.983-5.085h8.9Zm-9.7-8.109,3.274-8.382,3.271,8.382Z",
    transform: "translate(-133.459 -18.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M280.045,27.34V40.434a5.147,5.147,0,0,1-.6,2.526,4.227,4.227,0,0,1-1.687,1.688,5.326,5.326,0,0,1-2.556.6,5.127,5.127,0,0,1-2.5-.6,4.227,4.227,0,0,1-1.684-1.688,5.147,5.147,0,0,1-.6-2.526V27.34H267V40.434a8.454,8.454,0,0,0,1.018,4.188,6.988,6.988,0,0,0,2.855,2.767,8.831,8.831,0,0,0,4.289.975,9.273,9.273,0,0,0,4.415-.975,7.28,7.28,0,0,0,2.9-2.78,8.454,8.454,0,0,0,1.018-4.188V27.34Z",
    transform: "translate(-180.183 -18.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M340.151,27.34H324.06v3.125h6.321V48H333.8V30.465h6.347Z",
    transform: "translate(-218.693 -18.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M388.741,47.673a10.652,10.652,0,0,1-5.433-1.362,9.686,9.686,0,0,1-3.694-3.768,11.156,11.156,0,0,1-1.34-5.5,11.149,11.149,0,0,1,1.34-5.557,9.755,9.755,0,0,1,3.671-3.768,11.354,11.354,0,0,1,10.785,0,9.916,9.916,0,0,1,3.671,3.768,11.46,11.46,0,0,1,1.3,5.527,11.542,11.542,0,0,1-1.3,5.554,9.491,9.491,0,0,1-3.625,3.775A10.655,10.655,0,0,1,388.741,47.673Zm0-3.125a6.5,6.5,0,0,0,3.544-.975,6.61,6.61,0,0,0,2.406-2.679,8.539,8.539,0,0,0,.868-3.866,8.363,8.363,0,0,0-.894-3.9,7.039,7.039,0,0,0-2.429-2.679,7.131,7.131,0,0,0-7.153,0,6.746,6.746,0,0,0-2.455,2.679,8.255,8.255,0,0,0-.894,3.9,8.372,8.372,0,0,0,.894,3.9,6.981,6.981,0,0,0,2.478,2.679,7.29,7.29,0,0,0,3.635.94Z",
    transform: "translate(-255.278 -17.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M475.21,48V27.34h3.424V48Z",
    transform: "translate(-320.697 -18.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M515.268,27.34v15l-10.961-15H500.76V48h3.424V32.819L515.268,48h3.421V27.34Z",
    transform: "translate(-337.94 -18.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M577.225,47.627a10.252,10.252,0,0,1-5.306-1.362A9.794,9.794,0,0,1,568.3,42.5a11.461,11.461,0,0,1-1.3-5.527,11.461,11.461,0,0,1,1.3-5.527,9.638,9.638,0,0,1,3.622-3.768,10.369,10.369,0,0,1,12.2,1.34,8.805,8.805,0,0,1,2.107,2.949L583.1,33.226a6.678,6.678,0,0,0-1.437-1.983A6.753,6.753,0,0,0,579.6,29.9a6.148,6.148,0,0,0-2.429-.462,6.373,6.373,0,0,0-3.473.975,6.552,6.552,0,0,0-2.38,2.679,9.2,9.2,0,0,0,0,7.8,6.5,6.5,0,0,0,5.95,3.645,5.749,5.749,0,0,0,2.432-.52,6.473,6.473,0,0,0,2.032-1.44,7.437,7.437,0,0,0,1.437-2.133l3.125,1.265a9.628,9.628,0,0,1-5.232,5.16,9.956,9.956,0,0,1-3.843.751Z",
    transform: "translate(-382.638 -17.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M635.294,83.569a2.068,2.068,0,0,1-1.463-3.521,2.042,2.042,0,0,1,2.926,0,1.98,1.98,0,0,1,.618,1.463,1.951,1.951,0,0,1-.618,1.463A2,2,0,0,1,635.294,83.569Z",
    transform: "translate(-427.34 -53.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M24,25.283,38.306,0l4.11,6.828a1.886,1.886,0,0,1,.02,1.951L33.488,24.588a1.333,1.333,0,0,1-1.1.68Z",
    transform: "translate(-16.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M97.515,65.693,83.209,40.41,79.1,47.264a1.9,1.9,0,0,0-.016,1.951l8.968,15.773a1.317,1.317,0,0,0,1.1.68Z",
    transform: "translate(-53.194 -27.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M0,101.629H29.032l-3.9-6.965a1.922,1.922,0,0,0-1.691-.975H5.293a1.271,1.271,0,0,0-1.122.624Z",
    transform: "translate(0 -63.226)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e9fd4dcc680abd1a57f11d4f52cdf8b5.svg";
export { ForwardRef as ReactComponent };